import React from "react";
import { Controller } from "react-hook-form";
import { Col, Input, Label, Row } from "reactstrap";
import ValidationMsgComponent from "../ValidationMsgComponent";

interface ControlledTextFieldProps {
  label?: string;
  inputName: string | [string, string];
  inputType: string;
  placeholder?: string | [string, string];
  invalid?: boolean;
  control: any;
  rules?: object;
  errors?: object;
  register?: any;
  isRequired?: boolean;
  hasSideLabel?: boolean;
  sideLabel?: string;
  isDisabled?: boolean;
  defaultValue?: string | [string, string];
  className?: string;
  value?: string | FileList;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  multiple?: boolean;
}

type MyInputType =
  | "text"
  | "email"
  | "password"
  | "number"
  | "tel"
  | "url"
  | "search"
  | "date"
  | "datetime-local"
  | "time"
  | "week"
  | "month"
  | "color"
  | "file";

const TimeRangeSelector: React.FC<ControlledTextFieldProps> = ({
  label,
  inputName,
  inputType,
  placeholder,
  invalid,
  control,
  rules,
  errors,
  register,
  isRequired,
  hasSideLabel,
  sideLabel,
  isDisabled,
  defaultValue,
  className,
  onChange
}) => {
  const isRange = Array.isArray(inputName) && Array.isArray(defaultValue) && Array.isArray(placeholder);

  return (
    <div className="my-1">
      <Row>
        <Col lg="4">
          {isRange ? (
            <Label className={`pt-1 form-label`}>
              {isRequired ? `${label} ` : label}
            </Label>
          ) : (
            <Label className={`pt-1 form-label`} htmlFor={inputName as string}>
              {isRequired ? `${label} ` : label}
            </Label>
          )}
        </Col>
        <Col lg="8">
          {isRange ? (
            <>
              <Row>
                <Col>
                  <span className="px-2">From</span>
                  <Controller
                    name={inputName[0]}
                    control={control}
                    rules={rules}
                    defaultValue={defaultValue[0]}
                    render={({ field }) => (
                      <Input
                        id={inputName[0]}
                        type={inputType as MyInputType}
                        placeholder={placeholder[0]}
                        invalid={invalid}
                        disabled={isDisabled}
                        {...field}
                        className={className}
                        required={isRequired}
                        step={inputType === "number" ? "any" : undefined}
                        onChange={(e) => {
                          field.onChange(e);
                          if (onChange) {
                            onChange(e);
                          }
                        }}
                      />
                    )}
                  />
                </Col>
                <Col>
                  <span className="px-2">To</span>
                  <Controller
                    name={inputName[1]}
                    control={control}
                    rules={rules}
                    defaultValue={defaultValue[1]}
                    render={({ field }) => (
                      <Input
                        id={inputName[1]}
                        type={inputType as MyInputType}
                        placeholder={placeholder[1]}
                        invalid={invalid}
                        disabled={isDisabled}
                        {...field}
                        className={className}
                        required={isRequired}
                        step={inputType === "number" ? "any" : undefined}
                        onChange={(e) => {
                          field.onChange(e);
                          if (onChange) {
                            onChange(e);
                          }
                        }}
                      />
                    )}
                  />
                </Col>

              </Row>

            </>
          ) : (
            <Controller
              name={inputName as string}
              control={control}
              rules={rules}
              defaultValue={defaultValue as string}
              render={({ field }) => (
                <Input
                  id={inputName as string}
                  type={inputType as MyInputType}
                  placeholder={placeholder as string}
                  invalid={invalid}
                  disabled={isDisabled}
                  {...field}
                  className={className}
                  required={isRequired}
                  step={inputType === "number" ? "any" : undefined}
                  onChange={(e) => {
                    field.onChange(e);
                    if (onChange) {
                      onChange(e);
                    }
                  }}
                />
              )}
            />
          )}
          {hasSideLabel && <span className="ps-1 me-1">{sideLabel}</span>}
          {invalid && (
            <ValidationMsgComponent
              inputName={inputName as string}
              invalid={invalid}
              errors={errors}
              rules={rules}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TimeRangeSelector;

